






import { InjectReactive, Prop, Vue, Component } from 'vue-property-decorator'

@Component
export default class TabContent extends Vue {
    @Prop({ required: true }) readonly name!: string
    @InjectReactive() readonly activeTab!: string

    get isActive(): boolean {
        return this.activeTab === this.name
    }

    get componentClass(): object {
        return {
            'tab-content': true,
            'tab-content--active': this.isActive,
        }
    }
}
